export const options = [
    { label: '1 TON', value: '1' },
    { label: '5 TON', value: '5' },
    { label: '10 TON', value: '10' },
    { label: '50 TON', value: '50' },
    { label: '100 TON', value: '100' },
];
